import { ViteSSG } from "vite-ssg";
import App from "./App.vue";
import { configureApp } from "./app.js";
import { getRouterOptions, applyRouterEnhancements } from "./router.js";
import { createHead } from "@vueuse/head";

export const createApp = ViteSSG(App, getRouterOptions(), (context) => {
  applyRouterEnhancements(context.router);
  const head = createHead();
  configureApp(context.app, {
    router: context.router,
    head,
    registerRouter: false,
  });
});

export async function includedRoutes(paths, routes) {
  const { getAllPostPaths } = await import("./utils/BlogLoader.js");
  const { getAllUseCaseSlugs } = await import("./content/useCases.js");
  const blogPostPaths = getAllPostPaths();
  const useCasePaths = getAllUseCaseSlugs().map((s) => `/use-cases/${s}`);

  const extras = [
    // Static pages
    "/about",
    // Blog index
    "/blog",
    // All blog posts derived from src/content/blog/**/*.md
    ...blogPostPaths,
    // Use-case landing pages
    ...useCasePaths,
    // FAQ sections
    "/faq/welcome",
    "/faq/ads",
    "/faq/behavior",
    "/faq/business",
    "/faq/credits",
    "/faq/embedding",
    "/faq/how-to",
    "/faq/randomness",
    "/faq/saving",
    "/faq/sharing",
    "/faq/sound",
    "/faq/maintainer",
    "/faq/funding",
    "/faq/feedback",
    "/faq/privacy-summary",
  ];
  return Array.from(new Set([...paths, ...extras]));
}

export default createApp;
